import type { NavigateFunction, NavigateOptions } from 'react-router';

export type NativeNavigateHandler = (to: string, options?: NavigateOptions) => void;

const isSameUrl = (target: string, currentHref: string): boolean => {
  try {
    const currentUrl = new URL(currentHref);
    const targetUrl = new URL(target, currentUrl.href);
    return (
      targetUrl.origin === currentUrl.origin &&
      targetUrl.pathname === currentUrl.pathname &&
      targetUrl.search === currentUrl.search &&
      targetUrl.hash === currentUrl.hash
    );
  } catch {
    return false;
  }
};

export const createNativeNavigateHandler =
  (
    navigate: NavigateFunction,
    getCurrentHref: () => string = () => window.location.href
  ): NativeNavigateHandler =>
  (to, options) => {
    navigate(to, isSameUrl(to, getCurrentHref()) ? { ...options, replace: true } : options);
  };
